import { newNotification } from 'actions/ui/ui';
import {
  RESET_VALIDATION_ERRORS,
  SET_VALIDATION_ERRORS,
  UPDATE_READ_ONLY_FIELDS,
} from 'constants/fields';
import { CLEAR_FIELD_ERROR } from 'constants/ui';
import { getCurrentLocale } from 'selectors/ui/ui';
import type { PayexThunkAction } from 'store/configureStore';
import { supportUrl } from 'utils/flysiteUrls/flysiteUrls';

type ValidationErrors = Record<string, unknown>;

export const setValidationErrors =
  (
    errors: ValidationErrors,
    excludeUpdateReadOnlyFields?: string[],
  ): PayexThunkAction =>
  dispatch => {
    const updateReadOnlyPayload: ValidationErrors = {};

    for (const [key, value] of Object.entries(errors)) {
      if (!excludeUpdateReadOnlyFields?.includes(key)) {
        updateReadOnlyPayload[key] = value;
      }
    }

    dispatch({
      type: UPDATE_READ_ONLY_FIELDS,
      payload: updateReadOnlyPayload,
    });

    return dispatch({
      type: SET_VALIDATION_ERRORS,
      payload: errors,
    });
  };

export const setTermsErrors = () => {
  const error = { are_terms_accepted: ['not accepted'] };
  return setValidationErrors(error);
};

export const resetValidationErrors = () => ({
  type: RESET_VALIDATION_ERRORS,
});

export const clearFieldError = (fieldId: string) => ({
  type: CLEAR_FIELD_ERROR,
  payload: { fieldId },
});

export const taxErrorNotification =
  (): PayexThunkAction => (dispatch, getState) => {
    const state = getState();
    const locale = getCurrentLocale(state);

    dispatch(
      newNotification({
        message: 'taxError.message',
        opts: { contactUrl: supportUrl(locale) },
        type: 'error',
      }),
    );
  };
